import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Button,
  TextField,
  InputAdornment,
  Grid,
  Chip,
  Avatar,
  Card,
  CardContent,
  IconButton,
  Divider,
  FormControl,
  Select,
  MenuItem,
  Badge,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputLabel,
  ButtonGroup,
  Tabs,
  Tab,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Menu,
  CircularProgress,
  Tooltip,
  Stack,
  Alert
} from '@mui/material';
import {
  Add as AddIcon,
  Search as SearchIcon,
  LocationOn as LocationIcon,
  Visibility as ViewIcon,
  Description as InvoiceIcon,
  FilterList as FilterIcon,
  VerifiedUser as VerifiedIcon,
  TrendingUp as TrendingUpIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  TableChart as TableChartIcon,
  ViewModule as ViewModuleIcon,
  FileDownload as ExportIcon,
  DateRange as DateRangeIcon,
  MoreVert as MoreVertIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { customerService } from '../utils/apiService';
import ConfirmationModal from '../components/print/ConfirmationModal';
import ExportButton from '../components/ExportButton';

// Dummy data
const dummyCustomers = [
  {
    id: 1,
    code: 'CUST001',
    name: 'Al Noor Trading Co.',
    email: 'accounts@alnoor.com',
    streetName: 'King Fahd Road, Building 123',
    phone: '+966 55 123 4567',
    vatNumber: '300876543210003',
    type: 'B2B',
    status: 'Active',
  },
  {
    id: 2,
    code: 'CUST002',
    name: 'Jeddah Electronics Retail',
    email: 'sales@jeddahelec.com',
    streetName: 'Prince Sultan Street, Shop 45',
    phone: '+966 55 234 5678',
    vatNumber: '300765432100004',
    type: 'B2C',
    status: 'Active',
  },
  {
    id: 3,
    code: 'CUST003',
    name: 'Riyadh Services LLC',
    email: 'info@riyadhservices.sa',
    streetName: 'Olaya Street, Tower A',
    phone: '+966 55 345 6789',
    vatNumber: '300654321000005',
    type: 'B2B',
    status: 'Inactive',
  },
  {
    id: 4,
    code: 'CUST004',
    name: 'Dammam Supplies Center',
    email: 'orders@dammamsupplies.com',
    streetName: 'King Abdullah Road, Plaza 78',
    phone: '+966 55 456 7890',
    vatNumber: '300543210000006',
    type: 'B2B',
    status: 'Active',
  },
  {
    id: 5,
    code: 'CUST005',
    name: 'Office World Retail',
    email: 'customerservice@officeworld.sa',
    streetName: 'Tahlia Street, Mall Level 2',
    phone: '+966 55 567 8901',
    vatNumber: '300432100000007',
    type: 'B2C',
    status: 'Active',
  },
  {
    id: 6,
    code: 'CUST006',
    name: 'Gulf Trading Corporation',
    email: 'contact@gulftrading.com',
    streetName: 'King Faisal Road, Complex 12',
    phone: '+966 55 678 9012',
    vatNumber: '300321000000008',
    type: 'B2B',
    status: 'Active',
  },
  {
    id: 7,
    code: 'CUST007',
    name: 'Medina Tech Store',
    email: 'support@medinatech.sa',
    streetName: 'Qurban Street, Shop 34',
    phone: '+966 55 789 0123',
    vatNumber: '300210000000009',
    type: 'B2C',
    status: 'Inactive',
  },
  {
    id: 8,
    code: 'CUST008',
    name: 'Eastern Trading Group',
    email: 'info@easterntrading.com',
    streetName: 'King Khalid Road, Building 56',
    phone: '+966 55 890 1234',
    vatNumber: '300100000000010',
    type: 'B2B',
    status: 'Active',
  },
  {
    id: 9,
    code: 'CUST009',
    name: 'Western Electronics Outlet',
    email: 'sales@westernelec.com',
    streetName: 'Sitteen Street, Unit 89',
    phone: '+966 55 901 2345',
    vatNumber: '300000000000011',
    type: 'B2C',
    status: 'Active',
  },
  {
    id: 10,
    code: 'CUST010',
    name: 'Central Trading Enterprises',
    email: 'contact@centraltrading.sa',
    streetName: 'King Abdulaziz Road, Tower B',
    phone: '+966 55 012 3456',
    vatNumber: '300000000000012',
    type: 'B2B',
    status: 'Active',
  },
  {
    id: 11,
    code: 'CUST011',
    name: 'Tech Solutions Retail',
    email: 'customers@techsolutions.sa',
    streetName: 'Prince Mohammed Road, Shop 23',
    phone: '+966 55 123 7890',
    vatNumber: '300000000000013',
    type: 'B2C',
    status: 'Active',
  },
  {
    id: 12,
    code: 'CUST012',
    name: 'National Trading Co.',
    email: 'info@nationaltrading.com',
    streetName: 'King Saud Road, Building 45',
    phone: '+966 55 234 8901',
    vatNumber: '300000000000014',
    type: 'B2B',
    status: 'Inactive',
  },
  {
    id: 13,
    code: 'CUST013',
    name: 'City Electronics Store',
    email: 'sales@cityelectronics.sa',
    streetName: 'Al Olaya Road, Unit 67',
    phone: '+966 55 345 9012',
    vatNumber: '300000000000015',
    type: 'B2C',
    status: 'Active',
  },
  {
    id: 14,
    code: 'CUST014',
    name: 'United Trading Corporation',
    email: 'contact@unitedtrading.com',
    streetName: 'King Fahd Road, Complex 89',
    phone: '+966 55 456 0123',
    vatNumber: '300000000000016',
    type: 'B2B',
    status: 'Active',
  },
  {
    id: 15,
    code: 'CUST015',
    name: 'Modern Tech Retail',
    email: 'info@moderntech.sa',
    streetName: 'Prince Turki Road, Shop 12',
    phone: '+966 55 567 1234',
    vatNumber: '300000000000017',
    type: 'B2C',
    status: 'Active',
  }
];

const Customers = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState('table');
  const [activeTab, setActiveTab] = useState(0);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [filters, setFilters] = useState({
    status: {
      active: true,
      inactive: true,
    },
    type: {
      B2B: true,
      B2C: true,
    }
  });
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const exportColumns = [
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'vatRegistrationNumber', headerName: 'VAT Number', width: 150 },
    { field: 'email', headerName: 'Email', width: 200 },
    { field: 'phone', headerName: 'Phone', width: 150 },
    { field: 'address.street', headerName: 'Street', width: 200 },
    { field: 'address.city', headerName: 'City', width: 150 },
    { field: 'address.state', headerName: 'State', width: 150 },
    { field: 'address.postalCode', headerName: 'Postal Code', width: 120 },
    { field: 'address.country', headerName: 'Country', width: 150 },
    { field: 'customerType', headerName: 'Type', width: 100 },
    { field: 'isActive', headerName: 'Status', width: 100 }
  ];

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await customerService.getCustomers(page + 1, rowsPerPage);
      console.log('Customers API response:', response); // Debug log
      
      if (Array.isArray(response)) {
        setCustomers(response);
        setTotalCount(response.length);
      } else if (response && Array.isArray(response.customers)) {
        setCustomers(response.customers);
        setTotalCount(response.total || response.customers.length);
      } else {
        console.error('Invalid response format:', response);
        setError('Invalid response format from server');
        setCustomers([]);
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
      setError(error.message || 'Failed to load customers');
      setCustomers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, [page, rowsPerPage]);

  const handleDeleteClick = (customer) => {
    setSelectedCustomer(customer);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      if (selectedCustomer) {
        await customerService.deleteCustomer(selectedCustomer._id);
        fetchCustomers();
      }
    } catch (error) {
      console.error('Error deleting customer:', error);
    } finally {
      setDeleteModalOpen(false);
      setSelectedCustomer(null);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setSelectedCustomer(null);
  };

  const handleEditClick = (customer) => {
    if (customer && customer._id) {
      navigate(`/customers/edit/${customer._id}`);
    } else {
      console.error('Cannot edit customer: Invalid customer ID', customer);
      // Optionally show an error message to the user
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterChange = (category, value) => {
    setFilters(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        ...value,
      },
    }));
  };

  const filteredCustomers = customers.filter(customer => {
    if (!customer) return false;
    
    // Search filter
    const matchesSearch = searchQuery === '' || 
      (customer.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
       customer.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
       customer.vatRegistrationNumber?.toLowerCase().includes(searchQuery.toLowerCase()));
    
    // Tab-based filter
    const matchesTab = 
      activeTab === 0 || // All Customers tab
      (activeTab === 1 && customer.customerType === 'B2C') || // B2C Customers tab
      (activeTab === 2 && customer.customerType === 'B2B'); // B2B Customers tab
    
    // Status filter
    const matchesStatus = filters.status.active && customer.isActive || filters.status.inactive && !customer.isActive;
    
    // Type filter
    const matchesType = filters.type.B2B && customer.customerType === 'B2B' || filters.type.B2C && customer.customerType === 'B2C';
    
    return matchesSearch && matchesTab && matchesStatus && matchesType;
  });

  const paginatedCustomers = filteredCustomers.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Container maxWidth={false} sx={{ mt: 0.5, px: { xs: 0.5, sm: 1, md: 1, lg: 1 } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
        <Box>
        <Typography variant="h5" component="h1" fontWeight="bold">
          Customers
        </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            View all your customers information
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <ExportButton
            data={filteredCustomers}
            columns={exportColumns}
            filename="customers_export"
          />
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
            size="small"
          onClick={() => navigate('/customers/new')}
            sx={{ 
              borderRadius: '4px',
              textTransform: 'none',
              py: 0.5,
              px: 1,
            }}
        >
          Add Customer
        </Button>
        </Box>
      </Box>

      <Tabs 
        value={activeTab} 
        onChange={(event, newValue) => setActiveTab(newValue)}
        sx={{ 
          borderBottom: 1, 
          borderColor: 'divider',
          mb: 0.5,
          minHeight: 36,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 500,
            minWidth: 120,
            py: 0.5,
            minHeight: 36,
          }
        }}
      >
        <Tab label="All Customers" />
        <Tab label="B2C Customers" />
        <Tab label="B2B Customers" />
      </Tabs>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 2 }}>
        <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search for customers..."
            value={searchQuery}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{ 
              width: '100%',
              maxWidth: 500,
              height: 28,
              '& .MuiOutlinedInput-root': {
                borderRadius: '2px',
                height: 28,
              },
              '& .MuiInputBase-input': {
                py: 0.5,
              }
            }}
          />
            <Button
            variant="outlined"
            startIcon={<FilterIcon />} 
            size="small"
            onClick={handleFilterClick}
            sx={{ 
              borderRadius: '2px',
              textTransform: 'none',
              py: 0.25,
              px: 1,
              height: 28,
              ml: 'auto',
            }}
          >
            Filters
            </Button>
        </Box>
      </Box>

      <Menu
        anchorEl={filterAnchorEl}
        open={Boolean(filterAnchorEl)}
        onClose={handleFilterClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Status
          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.status.active}
                  onChange={(e) => handleFilterChange('status', { active: e.target.checked })}
                />
              }
              label="Active"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.status.inactive}
                  onChange={(e) => handleFilterChange('status', { inactive: e.target.checked })}
                />
              }
              label="Inactive"
            />
          </FormGroup>

          <Typography variant="subtitle1" sx={{ mt: 2 }} gutterBottom>
            Customer Type
                          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.type.B2B}
                  onChange={(e) => handleFilterChange('type', { B2B: e.target.checked })}
                />
              }
              label="B2B"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.type.B2C}
                  onChange={(e) => handleFilterChange('type', { B2C: e.target.checked })}
                />
              }
              label="B2C"
            />
          </FormGroup>
                  </Box>
      </Menu>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Paper 
        elevation={0} 
        sx={{ 
          p: 0.5, 
          mb: 0.5, 
          border: '1px solid rgba(0, 0, 0, 0.12)', 
          borderRadius: '4px',
        }}
      >
              <Box>
            <TableContainer>
              <Table size="small" sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                  <TableCell align="left" sx={{ fontWeight: 'medium', color: 'text.secondary', py: 0.5, width: '100px' }}>Code</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'medium', color: 'text.secondary', py: 0.5, minWidth: '200px' }}>Name</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'medium', color: 'text.secondary', py: 0.5, minWidth: '200px' }}>Email</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'medium', color: 'text.secondary', py: 0.5, minWidth: '150px' }}>Street Name</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'medium', color: 'text.secondary', py: 0.5, minWidth: '120px' }}>Phone No</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'medium', color: 'text.secondary', py: 0.5, minWidth: '150px' }}>VAT No</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'medium', color: 'text.secondary', py: 0.5, minWidth: '100px' }}>Type</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'medium', color: 'text.secondary', py: 0.5, minWidth: '100px' }}>Status</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'medium', color: 'text.secondary', py: 0.5, width: '100px' }}>Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                ) : filteredCustomers.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                      No customers found
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredCustomers.map((customer) => (
                    <TableRow
                      key={customer._id} 
                      hover
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left" sx={{ py: 0.5 }}>{customer.code || '-'}</TableCell>
                      <TableCell component="th" scope="row" sx={{ fontWeight: 'medium', py: 0.5 }}>
                        {customer.name || '-'}
                      </TableCell>
                      <TableCell align="left" sx={{ py: 0.5 }}>{customer.email || '-'}</TableCell>
                      <TableCell align="left" sx={{ py: 0.5 }}>{customer.address?.street || '-'}</TableCell>
                      <TableCell align="left" sx={{ py: 0.5 }}>{customer.phone || '-'}</TableCell>
                      <TableCell align="left" sx={{ py: 0.5 }}>{customer.vatRegistrationNumber || '-'}</TableCell>
                      <TableCell align="left" sx={{ py: 0.5 }}>{customer.customerType || '-'}</TableCell>
                      <TableCell align="center" sx={{ py: 0.5 }}>
                        <Chip 
                          label={customer.isActive ? 'Active' : 'Inactive'} 
                          size="small" 
                          color={customer.isActive ? 'success' : 'error'}
                          variant="outlined"
                          sx={{ 
                            fontWeight: 'medium',
                            backgroundColor: !customer.isActive ? 'rgba(211, 47, 47, 0.1)' : 'transparent'
                          }}
                        />
                      </TableCell>
                      <TableCell align="center" sx={{ py: 0.5 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                          <IconButton 
                            size="small" 
                            color="primary" 
                            sx={{ mx: 0.25, p: 0.5 }}
                            onClick={() => handleEditClick(customer)}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton 
                            size="small" 
                            color="error" 
                            sx={{ mx: 0.25, p: 0.5 }}
                            onClick={() => handleDeleteClick(customer)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
                </TableBody>
              </Table>
            </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredCustomers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
            sx={{
              borderTop: '1px solid rgba(0, 0, 0, 0.12)',
              '& .MuiTablePagination-select': {
                py: 0.5,
              },
              '& .MuiTablePagination-displayedRows': {
                fontSize: '0.875rem',
              }
            }}
          />
        </Box>
      </Paper>

      <ConfirmationModal
        open={deleteModalOpen}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        title="Delete Customer"
        message={`Are you sure you want to delete "${selectedCustomer?.name}"?`}
        confirmText="Delete"
        cancelText="Cancel"
      />
    </Container>
  );
};

export default Customers; 